export default __webpack_public_path__ + "static/loading-e33715067ef2cab8cf6d7c3f7255f3a6.gif";